import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import { serviceFactory } from '@/services';
import { EnrollmentSpecialistsService, type EnrollmentSpecialist } from '@/services/features/EnrollmentSpecialistsService.ts';

export const useEnrollmentSpecialists = () => {
  const { hasuraToken } = useAuth();

  // Get service instance
  const enrollmentSpecialistsService = serviceFactory.getService(EnrollmentSpecialistsService);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['enrollmentSpecialists'],
    queryFn: async (): Promise<EnrollmentSpecialist[]> => {
      if (!hasuraToken) {
        console.warn('No hasura token available, returning empty array');
        return [];
      }

      try {
        const response = await enrollmentSpecialistsService.fetchEnrollmentSpecialists();
        
        if (!response.success) {
          console.error('GraphQL API Error:', response.errors);
          return [];
        }

        const specialists = response.data?.pep_vw_enrollment_specialists || [];
        return specialists;
      } catch (error) {
        console.error('Error fetching enrollment specialists:', error);
        return [];
      }
    },
    enabled: !!hasuraToken,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    enrollmentSpecialists: data || [],
    isLoading,
    error,
    refetch,
  };
};